import { render, staticRenderFns } from "./datatable-version.component.vue?vue&type=template&id=249da200"
import script from "./datatable-version.component.vue?vue&type=script&lang=ts"
export * from "./datatable-version.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports